import gql from 'graphql-tag'
import cl from './client'

var client = cl.get()

function get_image_data (id) {
  return client
    .query({
      //prettier-ignore
      query: gql`query($id: ID!){ imageData(id: $id) }`,
      variables: { id: id }
    })
    .then(res => res.data.imageData)
}

export default {
  add_images_to_question: async q => {
    var r = []
    if (q.contentImage) {
      r.push(get_image_data(q.contentImage))
    }
    if (q.answerImages) {
      for (var j = 0; j < q.answerImages.length; ++j) {
        r.push(get_image_data(q.answerImages[j]))
      }
    }
    if (r.length == 0) {
      return q
    }
    r = await Promise.all(r)
    var k = 0
    if (q.contentImage) {
      q.contentImageData = r[k]
      k++
    }
    if (q.answerImages) {
      q.answerImagesData = []
      for (var j = 0; j < q.answerImages.length; ++j) {
        q.answerImagesData.push(r[k])
        k++
      }
    }
    return q
  },
  get_batches: _ =>
    client
      .query({
        // prettier-ignore
        query: gql`query{ 
          batches{
            id, desc, numTest, numAssignedTest, numFinishedTest
          }
        }`
      })
      .then(res => res.data.batches),
  get_testers: batchId =>
    client
      .query({
        // prettier-ignore
        query: gql`query($batchId: ID!) {
          testers {
            id, name
            assignedTests(batchId: $batchId) {
              id, numSequence, numSubmittedSequence, assignDate
            }
          }
        }`,
        variables: { batchId: batchId }
      })
      .then(res => res.data.testers),
  get_tests_by_batch: id =>
    client
      .query({
        // prettier-ignore
        query: gql`query($id: ID!){ 
          batch(id: $id){
            tests{
              id, numSequence, numSubmittedSequence,
              assignedTo { id, name },
            }
          }
        }`,
        variables: { id: id }
      })
      .then(res => (res.data.batch ? res.data.batch.tests : null)),
  get_reports: batchid =>
    client
      .query({
        // prettier-ignore
        query: gql`query($batchid: ID!){
            batch(id: $batchid){
              reports{
                id, type, checkType, testId, testSeqNo, message, 
                tester{id, name}, 
                question{key, templateId, ansref},
                refQuestion{key}
                verified
              }
            }
          }`,
        variables: { batchid: batchid }
      })
      .then(res =>
        res.data.batch
          ? res.data.batch.reports
            ? res.data.batch.reports
            : []
          : []
      ),
  get_question: key =>
    client
      .query({
        // prettier-ignore
        query: gql`query($key: ID!){
            question(key: $key){
              key, sno, type, layoutType, content, contentImage, answers, answerImages,
              solution{ data, type }
            }
          }`,
        variables: { key: key }
      })
      .then(res => res.data.question),
  get_testers_with_assigned_templates: batchid =>
    client
      .query({
        // prettier-ignore
        query: gql`query($batchid: ID!){
          testers{
            id, name,
            assignedTemplates(batchId: $batchid){
              id
            }
          }
        }`,
        variables: { batchid: batchid }
      })
      .then(res => res.data.testers),
  get_batch_fixed_template_ids: batchid =>
    client
      .query({
        query: gql`
          # prettier-ignore
          query($batchid: ID!){
            batch(id: $batchid){
              fixedTemplates{ id }
            }
          }
        `,
        variables: { batchid: batchid }
      })
      .then(res =>
        res.data.batch
          ? res.data.batch.fixedTemplates
            ? res.data.batch.fixedTemplates.map(x => x.id)
            : []
          : []
      ),
  // mutations
  unassign_test: id =>
    client
      .mutate({
        // prettier-ignore
        mutation: gql`
          mutation($id: ID!) {
            unassignTest(testId: $id) {
              success, message
            }
          }
        `,
        variables: { id: id }
      })
      .then(res => (res.data.unassignTest ? res.data.unassignTest : {})),
  assign_some_test: (testerid, num) =>
    client
      .mutate({
        // prettier-ignore
        mutation: gql`mutation($testerid: ID!, $num: Int!){
          assignSomeTest(testerId: $testerid, numTest: $num){
            success, numAssigned, message
          }
        }`,
        variables: { testerid: testerid, num: num }
      })
      .then(res => (res.data.assignSomeTest ? res.data.assignSomeTest : {})),
  update_tester_name: (testerid, name) =>
    client
      .mutate({
        // prettier-ignore
        mutation: gql`mutation($testerid: ID!, $name: String!){
          updateTesterName(testerId: $testerid, name: $name){
            success, message
          }
        }`,
        variables: { testerid: testerid, name: name }
      })
      .then(res =>
        res.data.updateTesterName ? res.data.updateTesterName : {}
      ),
  update_report_verified: (reportid, verified) =>
    client
      .mutate({
        // prettier-ignore
        mutation: gql`
          mutation($reportid: ID!, $verified: Boolean) {
            verifyReport(reportId: $reportid, verified: $verified) {
              success, message, reportId, verified
            }
          }
        `,
        variables: { reportid: reportid, verified: verified }
      })
      .then(res => (res.data.verifyReport ? res.data.verifyReport : {})),
  update_template_fixed: (batchid, templateid, fixed) =>
    client
      .mutate({
        // prettier-ignore
        mutation: gql`
          mutation($batchid: ID!, $templateid: ID!, $fixed: Boolean!){
            fixTemplate(batchId: $batchid, templateId: $templateid, 
              fixed: $fixed){
              success, message, templateId, fixed
            }
          }
        `,
        variables: {
          batchid: batchid,
          templateid: templateid,
          fixed: fixed
        }
      })
      .then(res => res.data.fixTemplate)
}
